export const blockIconsMapsMap = (
	<span className='material-symbols-outlined'>map</span>
);
